export { default } from './TraySelected'



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/TraySelected/index.js